import CustomText from "@components/CustomText";
import { colors } from "@constants/theme";

import React from "react";
import {
  TouchableOpacity,
  StyleSheet,
  View,
  ActivityIndicator,
} from "react-native";

function BottomButton({
  onPress = () => {},
  title = "",
  topComponent = null,
  loading = false,
  secondaryBtn = false,
  secondaryOnPress = () => {},
  secondaryTitle = "",
  bottomInset = 0,
}) {
  return (
    <View
      style={[
        styles.absoluteContainer,
        topComponent && { padding: 0 },
        { paddingBottom: (topComponent ? 0 : 10) + bottomInset },
      ]}
    >
      <View>
        <View style={{ marginBottom: 10 }}>{topComponent}</View>
      </View>
      <View style={{ flexDirection: "row" }}>
        <TouchableOpacity
          testID="docl-crate-scan"
          disabled={loading}
          activeOpacity={0.8}
          onPress={onPress}
          style={[
            styles.scanButton,
            topComponent && { marginHorizontal: 16 },
            { opacity: loading ? 0.8 : 1 },
          ]}
        >
          {loading ? (
            <ActivityIndicator size="small" color={colors.white} />
          ) : (
            <CustomText variant="title_16" style={styles.scanButtonText}>
              {title}
            </CustomText>
          )}
        </TouchableOpacity>
        {secondaryBtn && (
          <TouchableOpacity
            testID="docl-crate-scan-route"
            disabled={loading}
            activeOpacity={0.8}
            onPress={secondaryOnPress}
            style={[
              styles.scanButton,
              topComponent && { marginHorizontal: 16 },
              { opacity: loading ? 0.8 : 1 },
            ]}
          >
            {loading ? (
              <ActivityIndicator size="small" color={colors.white} />
            ) : (
              <CustomText variant="title_16" style={styles.scanButtonText}>
                {secondaryTitle}
              </CustomText>
            )}
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}

export default BottomButton;

const styles = StyleSheet.create({
  absoluteContainer: {
    backgroundColor: "white",
    position: "absolute",
    paddingBottom: 10,
    bottom: 0,
    width: "100%",
    padding: 16,
    elevation: 10,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  scanButton: {
    marginHorizontal: 6,
    flex: 1,
    backgroundColor: colors.plain_green,
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
  scanButtonText: {
    color: colors.white,
  },
});
